import React, { useState } from 'react'
import { Accordion, ModalContent, ModalHeader, ModalFooter, Spinner } from '@sainsburys-tech/bolt'

import * as Styled from './OrderSwatch.styles'

const BRAND = process.env.BRAND || 'ARGOS'

const OrderSwatch = ({ orderMessage, SKU, showSwatch = false }) => {
  const [showModal, toggleShowModal] = useState(false)
  const [iframeLoaded, toggleIframeLoaded] = useState(false)

  const PRIVACYURL = 'https://privacy-hub.sainsburys.co.uk/privacy-policy/'
  const COOKIEURL = 'https://privacy-hub.sainsburys.co.uk/cookie-policy/'

  const accordionOptions = {
    title: 'Terms and Conditions',
    'data-test': 'order-swatch-accordion',
    index: 'order-swatch-accordion'
  }

  return (
    showSwatch && (
      <>
        <Styled.ScrollableModal
          show={showModal}
          onClose={() => {
            toggleShowModal(false)
            toggleIframeLoaded(false)
          }}
        >
          <ModalHeader>Order a Fabric Sample</ModalHeader>
          <ModalContent>
            <Styled.SpinnerWrapper show={!iframeLoaded}>
              <Spinner size={100} />
            </Styled.SpinnerWrapper>
            <Styled.IframeContainer show={iframeLoaded}>
              <iframe
                name='swatchIframe'
                id='swatchIframe'
                onLoad={() => toggleIframeLoaded(true)}
                src={`/sofaswatch?brand=${BRAND.toLowerCase()}&sku=${SKU}`}
                title='Order Swatch'
              />
            </Styled.IframeContainer>
          </ModalContent>
          <ModalFooter>
            <p>
              For more information on how Argos Limited uses your personal details please refer to our{' '}
              <a href={PRIVACYURL} target='_blank' rel='noreferrer'>
                Privacy Policy
              </a>{' '}
              and{' '}
              <a href={COOKIEURL} target='_blank' rel='noreferrer'>
                Cookie Policy.
              </a>
            </p>
            <Accordion.Item noAnimation {...accordionOptions}>
              <p>
                Our swatches allow you to see the fabric and check the colour in the comfort of your home. To enjoy this
                service, please read the following:
              </p>
              <Styled.List>
                <li>1. To order single swatches, please use our online order form.</li>
                <li>
                  2. We will send your swatches to you within 3-5 working days of you placing your order. Orders placed
                  after 3pm will be processed the next working day.
                </li>
                <li>3. For any enquiries, please call 0345 601 4940.</li>
                <li>
                  4. For the purposes of administering this service, we may transfer data to reputable companies outside
                  the European Union. Whilst we take reasonable steps to ensure that your information will be afforded
                  the same level of protection as that required of us under applicable UK data protection legislation
                  you should be aware that countries outside the European Union may not offer the same level of
                  protection of personal data.
                </li>
              </Styled.List>
            </Accordion.Item>
          </ModalFooter>
        </Styled.ScrollableModal>
        <Styled.OrderSwatch data-test='order-swatch' className='top-border' role='link' tabIndex='0'>
          <Styled.OrderSwatchIcon />
          <a
            onClick={() => {
              toggleShowModal(true)
            }}
          >
            {orderMessage}
          </a>
        </Styled.OrderSwatch>
      </>
    )
  )
}

export default OrderSwatch
